export const CHOOSE_SERVICE = 'CHOOSE_SERVICE'
export const chooseService = (service_id, price) => ({
	type: CHOOSE_SERVICE,
	service_id,
	price
})

export const SET_COUNSELING_CENTER_USERNAME = 'SET_COUNSELING_CENTER_USERNAME'
export const setCounselingCenterUsername = (username) => ({
	type: SET_COUNSELING_CENTER_USERNAME,
	counseling_center_username: username
})

export const SET_CONSULTANT_USERNAME = 'SET_CONSULTANT_USERNAME'
export const setConsultantUsername = (username) => ({
	type: SET_CONSULTANT_USERNAME,
	consultant_username: username
})

export const SET_DATE = 'SET_DATE'
export const setDate = (date) => ({
	type: SET_DATE,
	date
})

export const SET_EN_DATE = 'SET_EN_DATE';
export const setEnDate = (date) => ({
  type: SET_EN_DATE,
	date
});

export const SET_TIME = 'SET_TIME'
export const setTime = (timeRange) => ({
	type: SET_TIME,
	time: timeRange.start_at,
	end_at: timeRange.end_at
})


export const SET_CONTACT_FORM = 'SET_CONTACT_FORM'
export const setContactForm = (fieldName, value) => ({
	type: SET_CONTACT_FORM,
	fieldName,
	value
})

export const GO_BACK_HANDLER = 'GO_BACK_HANDLER'
export const goBackHandler = (fieldName) => ({
	type: GO_BACK_HANDLER,
	fieldName
})

